/**
 * Spanish translations
 */

export default {
  'Enter your email': 'Introduce tu correo electrónico',
  'Not included': 'No está incluido',
  'Pause video': 'Pausar video',
  'Play video': 'Reproducir video',
  'Pricing plans': 'Planes de precios',
  'Select an option': 'Seleccionar una opción',
  'Sign up for GitHub': 'Inscríbete en GitHub',
  Country: 'País',
  'The following fields have errors:': 'Los siguientes campos contienen errores:',
  'You have the right to refuse the collection and use of your personal information, use of personal information or marketing purposes, and receiving marketing information as set forth above. However, if you refuse, you may not be able to receive the benefits described under Purpose of Collection & Use.':
    'Usted tiene derecho a rechazar la recopilación y el uso de su información personal, el uso de información personal con fines de marketing y la recepción de información de marketing como se indica arriba. Sin embargo, si se niega, es posible que no pueda recibir los beneficios descritos en el Propósito de Recopilación y Uso.',
  'I agree to the collection and use of my personal information (required)*.':
    'Acepto la recopilación y el uso de mi información personal (obligatorio)*.',
  'Items of Personal Information to be Collected: {fields}, and any other fields visible on this form.':
    'Elementos de información personal a recopilar: {fields}, y cualquier otro campo visible en este formulario.',
  'Purpose of Collection and Use: GitHub will use the data for the purpose described on this form.':
    'Propósito de la recopilación y uso: GitHub utilizará los datos para el propósito descrito en este formulario.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting':
    'Período de retención/uso de la información personal: Mientras sea necesario para proporcionar el/los servicio(s) que solicita.',
  'I agree to receiving marketing information and use of my personal information for marketing purposes (optional).':
    'Acepto recibir información de marketing y el uso de mi información personal para fines de marketing (opcional).',
  'Consent to Receive Marketing: The information collected may be used for GitHub for personalized communications, targeted advertising and campaign effectiveness.':
    'Consentimiento para recibir marketing: La información recopilada puede ser utilizada por GitHub para comunicaciones personalizadas, publicidad dirigida y efectividad de campañas.',
  'Purpose of Collection and Use: To contact you for marketing purposes.':
    'Propósito de la recopilación y uso: Para contactarlo con fines de marketing.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting.':
    'Período de retención/uso de la información personal: Mientras sea necesario para proporcionar el/los servicio(s) que solicita.',
  'Yes please, I’d like GitHub and affiliates to use my information for personalized communications, targeted advertising and campaign effectiveness. See the':
    'Sí, me gustaría que GitHub y sus afiliados utilizaran mi información para comunicaciones personalizadas, publicidad dirigida y eficacia de las campañas. Consulta la',
  'for more details.': 'para obtener más detalles.',
  'Participation requires transferring your personal data to other countries in which GitHub operates, including the United States. By submitting this form, you agree to the transfer of your data outside of China.':
    'La participación requiere transferir sus datos personales a otros países en los que GitHub opera, incluidos los Estados Unidos. Al enviar este formulario, acepta la transferencia de sus datos fuera de China.',
  'I will receive personalized communications and targeted advertising from GitHub and affiliates. See the':
    'Recibiré comunicaciones personalizadas y publicidad dirigida de GitHub y sus afiliados. Vea el',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'Sí, quiero recibir información de GitHub y su grupo de empresas por correo electrónico para comunicaciones personalizadas, publicidad dirigida y efectividad de campañas. Para retirar el consentimiento o administrar sus preferencias de contacto, visite el',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email and phone for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'Sí, quiero recibir información de GitHub y su grupo de empresas por correo electrónico y teléfono para comunicaciones personalizadas, publicidad dirigida y efectividad de campañas. Para retirar el consentimiento o administrar sus preferencias de contacto, visite el',
  'Promotional Communications Manager': 'Administrador de comunicaciones promocionales',
  'GitHub Privacy Statement': 'Declaración de privacidad de GitHub',
  'first name': 'nombre',
  'last name': 'apellido',
  company: 'empresa',
  email: 'correo electrónico',
  'This field is required.': 'Este campo es obligatorio.',
  'Please enter a valid work email address.':
    'Por favor, introduce una dirección de correo electrónico de trabajo válida.',
  'The email is from a personal email provider.': 'El correo electrónico es de un proveedor personal.',
  'Please enter a valid email address.': 'Por favor, introduce una dirección de correo electrónico válida.',
  'Please enter a valid phone number.': 'Por favor, introduce un número de teléfono válido.',
  'Please select your country/region': 'Por favor, selecciona tu país/región.',
  'Please complete the CAPTCHA.': 'Por favor, completa el CAPTCHA.',
  'Choose your country/region': 'Elige tu país/región.',
  Included: 'Incluido',
  Refresh: 'Actualizar',
  Unlimited: 'Sin límites',
  'Learn more': 'Aprende más',
  'Sort by:': 'Ordenar por:',
  'Selecting a sort option will reload the page.': 'Seleccionar una opción de orden recargará la página.',
  'Sort options': 'Opciones de orden',
  Sort: 'Ordenar',
  Newest: 'Más reciente',
  Oldest: 'Más antiguo',
  Whitepaper: 'White paper',
  'Content Type': 'Tipo de contenido',
  Category: 'Categoría',
  Whitepapers: 'White papers',
  Ebooks: 'Libros electrónicos',
  AI: 'IA',
  Cloud: 'Nube',
  DevOps: 'DevOps',
  'GitHub Actions': 'GitHub Actions',
  'GitHub Advanced Security': 'GitHub Advanced Security',
  'GitHub Enterprise': 'GitHub Enterprise',
  Innersource: 'Innersource',
  'Open Source': 'Código abierto',
  Security: 'Seguridad',
  'Software Development': 'Desarrollo de software',
  'Explore other resources': 'Explora otros recursos',
  Share: 'Compartir',
  'Ebooks & Whitepapers': 'Libros electrónicos y white papers',
  Tags: 'Tags',
  Ebook: 'Libros electrónicos',
  Platform: 'Plataforma',
  'AI CODE CREATION': 'CREACIÓN DE CÓDIGO CON IA',
  'GitHub Copilot': 'GitHub Copilot',
  'Write better code with AI': 'Escribe mejor código con IA',
  'GitHub Spark': 'GitHub Spark',
  'Build and deploy intelligent apps': 'Desarrolla y haz deployments de aplicaciones inteligentes',
  'GitHub Models': 'GitHub Models',
  'Manage and compare prompts': 'Administra y comparar peticiones',
  'MCP Registry (New)': 'Registro de MCP (Nuevo)',
  'Integrate external tools': 'Integra nuevas herramientas',
  'View all features': 'Ver todas las funciones',
  'DEVELOPER WORKFLOWS': 'FLUJOS DE TRABAJO DEL DESARROLLADOR',
  Actions: 'GitHub Actions',
  'Automate any workflow': 'Automatiza cualquier flujo de trabajo',
  Codespaces: 'Codespaces',
  'Instant dev environments': 'Entornos de desarrollo instantáneos',
  Issues: 'GitHub Issues',
  'Plan and track work': 'Planifica y realiza el seguimiento del trabajo',
  'Code review': 'Revisión del código',
  'Manage code changes': 'Gestiona los cambios en el código',
  'APPLICATION SECURITY': 'SEGURIDAD DE LA APLICACIÓN',
  'Find and fix vulnerabilities': 'Encuentra y corrige vulnerabilidades',
  'Code Security': 'Code Security',
  'Secure your code as you build': 'Protege tu código mientras lo creas',
  'Secret Protection': 'Secret Protection',
  'Stop leaks before they start': 'Acaba con las filtraciones antes de que ocurran',
  EXPLORE: 'EXPLORA',
  'Why GitHub': 'Por qué usar GitHub',
  Documentation: 'Documentación',
  Blog: 'Blog',
  Changelog: 'Changelog',
  'GitHub Marketplace': 'GitHub Marketplace',
  Solutions: 'Soluciones',
  'BY COMPANY SIZE': 'POR TAMAÑO DEL NEGOCIO',
  Enterprises: 'Empresas',
  'Small and medium teams': 'Equipos pequeños y medianos',
  Startups: 'Startups',
  Nonprofits: 'Organizaciones sin ánimo de lucro',
  'View all solutions': 'Ver todas las soluciones',
  'BY USE CASE': 'POR CASO DE USO',
  'App modernization': 'Modernización de la aplicación',
  DevSecOps: 'DevSecOps',
  'View all use cases': 'Ver todos los casos de uso',
  'BY INDUSTRY': 'POR SECTOR',
  Healthcare: 'Servicios de la salud',
  'Financial services': 'Servicios financieros',
  Manufacturing: 'Fabricación',
  Government: 'Gobierno',
  'View all industries': 'Ver todos los sectores',
  Resources: 'Recursos',
  'EXPLORE BY TOPIC': 'EXPLORAR POR TEMA',
  'Software development': 'Desarrollo de software',
  'View all topics': 'Ver todos los temas',
  'EXPLORE BY TYPE': 'EXPLORAR POR TIPO',
  'Customer stories': 'Historias de clientes',
  'Events & webinars': 'Eventos y seminarios web',
  'Ebooks & reports': 'Libros electrónicos e informes',
  'Business insights': 'Información sobre el negocio',
  'GitHub Skills': 'GitHub Skills',
  'SUPPORT & SERVICES': 'ASISTENCIA Y SERVICIOS',
  Customer: 'Asistencia al cliente',
  'Customer support': 'Asistencia al cliente',
  'Community forum': 'Foro de la comunidad',
  'Trust Center': 'Trust Center',
  Partners: 'Partners',
  COMMUNITY: 'COMUNIDAD',
  'GitHub Sponsors': 'GitHub Sponsors',
  'Fund open source developers': 'Financia a los desarrolladores de código abierto',
  'The ReadME Project': 'El proyecto ReadME',
  'GitHub community articles': 'Artículos de la comunidad GitHub',
  'COMMUNITY PROGRAMS': 'PROGRAMAS DE LA COMUNIDAD',
  'Security Lab': 'Security Lab',
  'Maintainer Community': 'Comunidad de mantenedores',
  Accelerator: 'Accelerator',
  'Archive Program': 'Archivar programa',
  REPOSITORIES: 'REPOSITORIOS',
  Topics: 'Temas',
  Trending: 'Tendencias',
  Collections: 'Colecciones',
  Enterprise: 'Enterprise',
  'ENTERPRISE SOLUTIONS': 'SOLUCIONES EMPRESARIALES',
  'Enterprise platform': 'Plataforma Enterprise',
  'AI-powered developer platform': 'Plataforma para desarrolladores impulsada por IA',
  'AVAILABLE ADD-ONS': 'COMPLEMENTOS DISPONIBLES',
  'Enterprise-grade application security': 'Seguridad de la aplicación de calidad empresarial',
  'Copilot for Business': 'Copilot for Business',
  'Enterprise-grade AI features': 'Funciones de IA de calidad empresarial',
  'Premium Support': 'Soporte premium',
  'Enterprise-grade 24/7 support': 'Asistencia 24/7 de calidad empresarial',
  New: 'Nuevo',
  Select: 'Seleccione',
  'Install with script': 'Instalar con script',
  'Install with npm': 'Instalar con npm',
  'Install with Homebrew': 'Instalar con Homebrew',
  'Install with WinGet': 'Instalar con WinGet',
  Copy: 'Copiar',
  'Copy installation command': 'Copiar comando de instalación',
  'Copied to clipboard': 'Copiado al portapapeles',
  'Select install method': 'Selecciona el método de instalación',
  'Get Copilot CLI': 'Obtén Copilot CLI',
  'Read the documentation.': 'Lee la documentación.',
  'Included in Copilot Free, Pro, Pro+, Business, and Enterprise subscriptions.':
    'Incluido en las suscripciones de Copilot Free, Pro, Pro+, Business y Enterprise.',
  'Included in Copilot Free, Pro, Pro+, Max, Business, and Enterprise subscriptions.':
    'Incluido en las suscripciones de Copilot Free, Pro, Pro+, Max, Business y Enterprise.',
  'Available with Copilot Free, Pro, Pro+, Business, and Enterprise.':
    'Disponible con Copilot Free, Pro, Pro+, Business y Enterprise.',
  'Available with Copilot Free, Pro, Pro+, Max, Business, and Enterprise.':
    'Disponible con Copilot Free, Pro, Pro+, Max, Business y Enterprise.',
  'View all resources': 'Ver todos los recursos',
  'Enterprise-grade security features': 'Funciones de seguridad de calidad empresarial',
  Pricing: 'Precios',
  'Select country for phone number. Currently selected:':
    'Seleccionar país para el número de teléfono. Selección actual:',
  'Search countries': 'Buscar países',
  'Search countries...': 'Buscar países...',
  Countries: 'Países',
  'No countries found': 'No se encontraron países',
  '{count} result available': '{count} resultado disponible',
  '{count} results available': '{count} resultados disponibles',
  'Get the ebook': 'Obtén el libro electrónico',
  'Get the analysis': 'Obtener el análisis',

  // Marketing footer
  Subscribe: 'Suscríbete',
  Ecosystem: 'Entorno',
  Support: 'Soporte',
  Company: 'Empresa',
  Features: 'Características',
  Team: 'Team',
  Roadmap: 'Roadmap',
  'Compare GitHub': 'Compara GitHub',
  'Developer API': 'API de desarrollador',
  Education: 'Educación',
  Docs: 'Documentación',
  'Community Forum': 'Foro de la comunidad',
  'Professional Services': 'Servicios profesionales',
  Skills: 'Habilidades',
  Status: 'Estado',
  'Contact GitHub': 'Contactar a GitHub',
  About: 'Acerca de',
  Careers: 'Trabajos',
  Newsroom: 'Sala de prensa',
  Inclusion: 'Inclusión',
  'Social Impact': 'Impacto social',
  Shop: 'Tienda',
  'What is Git?': '¿Qué es Git?',
  Sitemap: 'Mapa del sitio web',
  Terms: 'Términos',
  Privacy: 'Privacidad',
  'Manage cookies': 'Administrar cookies',
  'Do not share my personal information': 'No compartir mi información personal',

  // Marketing footer — newsletter heading/description reuse legacy copy; "Customer Stories" reuses legacy "Customer stories" (pending loc review)
  'The developer newsletter': 'Suscríbete a nuestro boletín para desarrolladores',
  'Get tips, technical guides, and best practices. Twice a month. Right in your inbox.':
    'Obtén consejos, guías técnicas y prácticas recomendadas. Dos veces al mes.',
  'Customer Stories': 'Historias de clientes',

  // Marketing footer — a11y/nav and social labels (drafted, pending loc verification)
  'Go to GitHub homepage': 'Ir a la página principal de GitHub',
  'Site-wide Links': 'Enlaces de todo el sitio',
  'Legal and Resource Links': 'Enlaces legales y de recursos',
  "GitHub's Social Media Links": 'Enlaces de redes sociales de GitHub',
  'Select language': 'Seleccionar idioma',
  'GitHub on LinkedIn': 'GitHub en LinkedIn',
  'GitHub on Instagram': 'GitHub en Instagram',
  'GitHub on YouTube': 'GitHub en YouTube',
  'GitHub on X': 'GitHub en X',
  'GitHub on TikTok': 'GitHub en TikTok',
  'GitHub on Twitch': 'GitHub en Twitch',
  'GitHub’s organization on GitHub': 'La organización de GitHub en GitHub',
  // Add more translations here
}
